import React from 'react';
import { OverlayTrigger, Tooltip } from '@/components/ui';

interface InfoTooltipProps {
  content: React.ReactNode;
  id?: string;
  placement?: 'top' | 'bottom' | 'left' | 'right';
  maxWidth?: string;
  children: React.ReactNode;
}

/**
 * Shared tooltip for informational hover copy.
 * Relies on OverlayTrigger hover/focus (portaled) so it is not clipped by
 * overflow:hidden table headers or other ancestors.
 */
export const InfoTooltip: React.FC<InfoTooltipProps> = ({
  content,
  id,
  placement = 'top',
  maxWidth = '450px',
  children
}) => {
  if (!content) {
    return <>{children}</>;
  }

  return (
    <OverlayTrigger
      placement={placement}
      overlay={
        <Tooltip id={id || 'info-tooltip'} style={{ maxWidth }}>
          <div className="tw-text-left">{content}</div>
        </Tooltip>
      }
    >
      <span className="tw-inline-flex tw-cursor-help tw-items-center">
        {children}
      </span>
    </OverlayTrigger>
  );
};

export default InfoTooltip;
